import { useState } from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

export type SortDir = 'asc' | 'desc' | null;

/**
 * Toggle hook for ascending/descending sort on the part_number column,
 * used by the Stock Planning sub-tabs. Click cycles null -> asc -> desc -> asc...
 *
 * @param onChange - Optional callback fired before the direction flips
 *                   (e.g. to reset pagination to page 1).
 * @returns sortDir current direction, ordering query-param value or null,
 *          icon element for the header, and toggle click handler.
 */
export function usePartNumberSort(onChange?: () => void) {
  const [sortDir, setSortDir] = useState<SortDir>(null);

  const toggle = () => {
    onChange?.();
    setSortDir(prev => (prev === null ? 'asc' : prev === 'asc' ? 'desc' : 'asc'));
  };

  const ordering: string | null = sortDir === 'asc'
    ? 'part_number'
    : sortDir === 'desc'
      ? '-part_number'
      : null;

  const icon = sortDir === 'asc'
    ? <ArrowUp className="h-3 w-3 text-primary" />
    : sortDir === 'desc'
      ? <ArrowDown className="h-3 w-3 text-primary" />
      : <ArrowUpDown className="h-3 w-3 text-muted-foreground" />;

  return { sortDir, ordering, icon, toggle };
}
